import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { handleError } from '../../utilities/errorHandler';
import {addSite, allSites, oneSite, removeSite, updateSite} from '../../services/sites';
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import CustomLoader from '../shared/CustomLoader';
import SitesTable from './../tables/SitesTable';
import SiteForm from './../forms/SiteForm';

const Sites = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [sites, setSites] = useState([]);
    const [site, setSite] = useState(null);
    const [message, setMessage] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const getSites = useCallback( async () => {
        setIsLoading(true);
        try {
            const response = await allSites();
            if (response.status === 200){
                setSites(response.data);
            }
        } catch (error){
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getSites();
    }, [getSites]);

    const getSite = (id) => {
        oneSite(id).then((response) => {
            if (response.status === 200){
                setSite(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const saveSite = async (data) => {
        setIsSaving(true);
        try {
            const siteData = {
                name: data.name,
                client_id: data.client.value,
                supervisor_id: data.supervisor.value,
                longitude: data.longitude,
                latitude: data.latitude,
                geo_fence_radius: data.geo_fence_radius,
            };

            if (data.id){
                await updateSite(data.id, siteData);
                handleMessage('Site details successfully updated', 'success');
                getSites();

                return true;
            } else {
                await addSite(siteData);
                handleMessage('Site details successfully saved.', 'success');
                getSites();

                return true;
            }
        } catch (error){
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e) {
                // 422 errors will be handled by onSubmit() in SiteForm.jsx
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }

    const deleteSite = (id) => {
        try {
            removeSite(id);
            handleMessage('Site successfully removed!', 'success');
            getSites();
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        }
    }

  return (
    <Container fluid>

        <PageTitle title='Site Details' />

        <Message
            show={message.show}
            message={message.text}
            handleClose={handleCloseMessage}
            variant={message.variant}
        />

        <SiteForm 
            isSaving={isSaving}
            formAction={saveSite}
            site={site}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <SitesTable 
                    sites={sites}
                    onDelete={deleteSite}
                    onEdit={getSite}
                />
            )
        }

    </Container>
  )
}

export default Sites